import React, { Component } from 'react';
import { Email, Telefone } from '../../../Componentes';
import api from '@api';

export default class ListarConcedentes extends Component {
	constructor() {
		super();
		this.state = {
			listaDeConcedentes: [],
			loadingIds: [],
		};

		this.carregarListaDeConcedentes = this.carregarListaDeConcedentes.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.carregarListaDeConcedentes();
	}

	carregarListaDeConcedentes() {
		api.concedentes.ListaConcedentes()
			.then((listaDeConcedentes) => {
				this.setState({ listaDeConcedentes });
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	linkParaBaixarAcordoDeCooperacao(id) {
		return `${api.concedentes.getBaseUrl()}/${id}/baixar`;
	}

	isLoading(id) {
		return this.state.loadingIds.includes(id);
	}

	setLoading(id) {
		this.setState(state => state.loadingIds.includes(id)
			? state
			: ({
				...state,
				loadingIds: [...state.loadingIds, id],
			}));
	}

	setLoaded(id) {
		this.setState(state => !state.loadingIds.includes(id)
			? state
			: ({
				...state,
				loadingIds: state.loadingIds.filter(v => v !== id),
			}));
	}

	async baixar(id) {
		const token = api.auth.accessToken();
		const link = this.linkParaBaixarAcordoDeCooperacao(id);

		this.setLoading(id);
		await fetch(link, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then(res => res.arrayBuffer())
			.then(buffer => {
				const blob = new Blob([buffer], { type: 'application/pdf' });
				const blobUrl = URL.createObjectURL(blob);

				this.setState(prevState => {
					const { listaDeConcedentes } = prevState;

					const concedente = listaDeConcedentes.filter(concedente => concedente.id === id)[0];
					const concedenteAtualizado = { ...concedente, blobUrl };

					const listaDeConcedentesAtualizada = listaDeConcedentes.reduce((listaNova, valorOriginal) => {
						listaNova.push(valorOriginal.id === id ? concedenteAtualizado : valorOriginal);
						return listaNova;
					}, []);

					return ({
						...prevState,
						listaDeConcedentes: [...listaDeConcedentesAtualizada],
					});
				});
			});
		this.setLoaded(id);
	}

	render() {
		const { listaDeConcedentes } = this.state;

		return (
			<div>
				<h5>Relação de Concedentes</h5>
				<table className="table table-striped table-hover">
					<thead>
						<tr>
							<th />
							<th>Nome</th>
							<th>Contatos</th>
							<th>Endereço</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{
							listaDeConcedentes.map(({ endereco, ...concedente }, i) => (
								<tr key={concedente.id} title={concedente.observacoes}>
									<td>
										{i + 1}
									</td>
									<td>
										{concedente.nome}
										<div>
											<small>{concedente.identificacao_cadastral.tipo_de_cadastro}: {concedente.identificacao_cadastral.codigo_de_cadastro} | </small>
											<small>{concedente.ramo_atividade}</small>
										</div>
									</td>
									<td>
										<div><Telefone value={concedente.telefone} /></div>
										<div><Email value={concedente.email} /></div>
									</td>
									<td>
										{endereco.logradouro}, {endereco.bairro}, {endereco.cidade}-{endereco.uf} ({endereco.cep})
									</td>
									<td>
										{concedente.blobUrl === undefined
											? this.isLoading(concedente.id)
												? 'Baixando...'
												: <button onClick={() => this.baixar(concedente.id)}>Baixar</button>
											: <button onClick={() => window.open(concedente.blobUrl, '_blank')}>Abrir</button>}
									</td>
								</tr>
							))
						}
					</tbody>
				</table>
			</div>
		);
	}
}
